import { FC } from 'react';
import { Box, Button, TextField } from '@mui/material';
import { Check, Close } from '@mui/icons-material';

interface RenameFormProps {
  value: string;
  error: string | null;
  isPending: boolean;
  onChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

const RenameForm: FC<RenameFormProps> = ({
  value,
  error,
  isPending,
  onChange,
  onConfirm,
  onCancel,
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    <TextField
      size="small"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      error={Boolean(error)}
      helperText={error || '拡張子が無い場合は自動で.csvを付与します。'}
      autoFocus
    />
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Button
        size="small"
        variant="contained"
        startIcon={<Check />}
        onClick={onConfirm}
        disabled={isPending}
      >
        保存
      </Button>
      <Button
        size="small"
        variant="outlined"
        startIcon={<Close />}
        onClick={onCancel}
        disabled={isPending}
      >
        キャンセル
      </Button>
    </Box>
  </Box>
);

export default RenameForm;
